import 'babel-polyfill';
import objectFitImages from 'object-fit-images';
import './object-assign-polyfill';

/*
 * In this file, all kinds of initializations that vary from project to project are performed.
 */

import '../styles/main.scss';
import loadFonts from './utils/load-fonts';
import './elements/scroll-to-top';
import './elements/preloader';
import './elements/cookies';
import './scrollmagic';
import './custom-selects';
import './blocks/slider';
import './blocks/contact';
import './blocks/shuffle';
import './elements/header-nav';
//import './utils/object-fit-fix';
import './parallax';
import './elements/back-to-hp'

document.addEventListener('DOMContentLoaded', () => {
    loadFonts(['Prata:400:latin', 'Montserrat:300,400,500,600:latin']);

    // initHeaderNav({
	// 	menuContainer: '.menu__section_categories',
	// 	menuWrapper: '.header__menu-wrapper',
	// 	transitionDuration: 450, //$_menu-duration in scss file.
	// });

    // $('.current-year').text((new Date()).getFullYear());
    //
    // $('.form').each(function () {
    //     const $form = $(this);
    //     const $button = $form.find('.button');
    //
    //     $form.hevensForm({
    //         async: true,
    //         captchaCallback: key => {
    //             document.getElementById('g-recaptcha-response').value = key;
    //         },
    //         //captchaKey: '6LclyTAUAAAAAORhoSg2OvcAzkEbtZU2xUqx-0nP',
    //         doSending: !document.documentElement.classList.contains('no-cms'),
    //         minProgressDuration: 2000
    //     }).on('progressStart', () => {
    //         $button.addClass('button_progress');
    //     }).on('progressEnd', () => {
    //         $button.removeClass('button_progress');
    //     })
    // });

    // $('.input-block').filter((i, el) => $(el).closest('.form').length === 0).hevensInputBlock();

    // $('.button').each((i, el) => el.innerHTML = `<span>${el.innerHTML}</span>`); // to acheive CSS hover effect on all buttons
    objectFitImages();
});



// WEBPACK FOOTER //
// ./scripts/main.js